import React from 'react';
import PropTypes from 'prop-types';
import { nanoid } from '@reduxjs/toolkit';
import cn from 'classnames';

export default function Checkbox(props) {
  const {
    label,
    checked = false,
    onChange,
    disabled = false,
    wrapClassNames
  } = props;

  return (
    <div className={cn('form-input form-input__checkbox', wrapClassNames)}>
      <label>
        <input
          type="checkbox"
          checked={checked}
          onChange={onChange}
          disabled={disabled}
        />
        <span
          className={`form-input__checkmark ${disabled ? 'disabled' : ''}`}
        />
        <span className={`form-input__value ${disabled ? 'disabled' : ''}`}>
          {label}
        </span>
      </label>
    </div>
  );
}

Checkbox.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  onChange: PropTypes.func.isRequired,
  checked: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  wrapClassNames: PropTypes.string,
};
